import React from 'react';

import { renderComponent } from 'app/src/components/ComponentWrapper';
import type { Board } from './PluginHeaderButton.types';
import { PluginHeaderHubButton } from './PluginHeaderHubButton';

export const renderPluginDropdownList = (
  container: Element,
  board: Board,
  openDirectory: () => void,
  openPluginSettings: (pluginId: string) => void,
) => {
  if (!container) {
    return;
  }

  return renderComponent(
    React.createElement(PluginHeaderHubButton, {
      board: board,
      openDirectory: openDirectory,
      openPluginSettings: openPluginSettings,
    }),
    container,
  );
};
